export type DuracionAudio = '30' | '60' | '90';

export type UsoAudio = 'saludo' | 'concurso' | 'participacion' | 'mensaje';

export type EstadoModeracion = 'pendiente' | 'aprobado' | 'rechazado' | 'destacado';

export interface AudioMensaje {
  id: number;
  duracion: DuracionAudio;
  duracionSegundos: number;
  uso: UsoAudio;
  texto: string;
  remitente: string;
  remitenteAvatar: string;
  remitenteCiudad: string;
  remitentePlan: string;
  destinoNombre: string;
  destinoRadio: string;
  estado: EstadoModeracion;
  fechaGrabacion: string;
  fechaModeracion?: string;
  fechaDestacado?: string;
  motivoRechazo?: string;
  compartidos: number;
  score: number;
  escuchas: number;
}

export interface ScoreAccionAudio {
  id: string;
  accion: string;
  icono: string;
  color: string;
  descripcion: string;
  puntos: number;
}

export interface ReglaAudio {
  id: number;
  titulo: string;
  descripcion: string;
  icono: string;
  color: string;
}

export const coverImage = 'https://readdy.ai/api/search-image?query=Warm%20broadcast%20studio%20with%20microphone%20on%20a%20wooden%20desk%2C%20soundproof%20panels%20in%20warm%20cream%20tones%2C%20acoustic%20foam%20diffusers%2C%20soft%20amber%20lighting%2C%20vintage%20audio%20equipment%2C%20professional%20recording%20environment%2C%20cozy%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20rich%20warm%20color%20palette%20of%20amber%20cream%20and%20warm%20brown&width=1600&height=900&seq=audio-mensajes-hero-x1&orientation=landscape';

export const audioMensajes: AudioMensaje[] = [
  {
    id: 1,
    duracion: '60',
    duracionSegundos: 60,
    uso: 'saludo',
    texto: 'Hola a todos los que están en Cabina. Soy Carlos desde San José, quería mandar un abrazo enorme a toda la comunidad de Estéreo Capital. Los escucho todas las mañanas camino al brete y son mi motor para arrancar el día con buena energía. ¡Pura vida gente!',
    remitente: 'Carlos Ramírez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20friendly%20face%2C%20casual%20polo%20shirt%2C%20natural%20daylight%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=audio-carlos&orientation=squarish',
    remitenteCiudad: 'San José',
    remitentePlan: 'Plan Pro',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'destacado',
    fechaGrabacion: '2026-06-21T14:15:00',
    fechaModeracion: '2026-06-21T14:18:00',
    fechaDestacado: '2026-06-21T14:22:00',
    compartidos: 156,
    score: 390,
    escuchas: 892,
  },
  {
    id: 2,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'concurso',
    texto: 'Mi respuesta para el concurso de hoy: la canción que más veces han pedido esta semana es Vivir Mi Vida de Marc Anthony. ¡Y también es mi favorita! Saludos a Valentina y todo el equipo.',
    remitente: 'Sofía Hernández',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=audio-sofia&orientation=squarish',
    remitenteCiudad: 'San José',
    remitentePlan: 'Plan Básico',
    destinoNombre: 'Tardes con Vale',
    destinoRadio: 'Estéreo Capital',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-21T13:45:00',
    fechaModeracion: '2026-06-21T13:50:00',
    compartidos: 34,
    score: 85,
    escuchas: 245,
  },
  {
    id: 3,
    duracion: '90',
    duracionSegundos: 90,
    uso: 'mensaje',
    texto: 'Quiero agradecerles de corazón por el espacio que le dan a los artistas nacionales. Soy músico de Heredia, tengo una banda que se llama Los Ecos del Valle, y gracias a que nos pasaron en el programa conseguimos nuestro primer concierto en vivo. La radio cambia vidas, de verdad. Gracias infinitas.',
    remitente: 'Tomás Blanco',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20creative%20style%2C%20thoughtful%20expression%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=audio-tomas&orientation=squarish',
    remitenteCiudad: 'Heredia',
    remitentePlan: 'Plan Premium',
    destinoNombre: 'Modo Creativo',
    destinoRadio: 'Radio Élite Digital',
    estado: 'destacado',
    fechaGrabacion: '2026-06-21T11:20:00',
    fechaModeracion: '2026-06-21T11:25:00',
    fechaDestacado: '2026-06-21T11:30:00',
    compartidos: 278,
    score: 695,
    escuchas: 1534,
  },
  {
    id: 4,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'participacion',
    texto: 'Hola equipo, participando en el debate de hoy sobre fútbol nacional. Yo digo que Alajuelense llega a la final este año sí o sí. Los números no mienten. Vamos manudos.',
    remitente: 'Roberto Sánchez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20style%2C%20friendly%20expression%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=audio-roberto&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    remitentePlan: 'Plan Pro',
    destinoNombre: 'Deporte Total',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-21T16:30:00',
    fechaModeracion: '2026-06-21T16:33:00',
    compartidos: 67,
    score: 134,
    escuchas: 410,
  },
  {
    id: 5,
    duracion: '60',
    duracionSegundos: 60,
    uso: 'saludo',
    texto: 'Buenas tardes desde Cartago. Hoy cumplo 10 años de escuchar Tardes con Vale todas las tardes. Me han acompañado en mis momentos más felices y en los más difíciles. Gracias Valentina por tanto cariño, gracias equipo por hacer el mejor programa del país.',
    remitente: 'Ana Patricia Vega',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latina%20woman%2C%20elegant%20casual%20style%2C%20warm%20genuine%20smile%2C%20soft%20natural%20light%2C%20clean%20background&width=80&height=80&seq=audio-ana&orientation=squarish',
    remitenteCiudad: 'Cartago',
    remitentePlan: 'Plan Pro',
    destinoNombre: 'Tardes con Vale',
    destinoRadio: 'Estéreo Capital',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-21T12:50:00',
    fechaModeracion: '2026-06-21T12:55:00',
    compartidos: 89,
    score: 178,
    escuchas: 567,
  },
  {
    id: 6,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'concurso',
    texto: 'Respuesta al concurso de la trivia musical: las tres canciones que empataron en el ranking de más pedidas esta semana son Vivir Mi Vida, Bailando y Despacito. Espero ganarme la camiseta.',
    remitente: 'Camila Soto',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20modern%20trendy%20style%2C%20bright%20genuine%20smile%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=audio-camila&orientation=squarish',
    remitenteCiudad: 'Cartago',
    remitentePlan: 'Plan Básico',
    destinoNombre: 'Trivia Musical RFW',
    destinoRadio: 'Estéreo Capital',
    estado: 'rechazado',
    fechaGrabacion: '2026-06-21T15:10:00',
    fechaModeracion: '2026-06-21T15:15:00',
    motivoRechazo: 'Respuesta incorrecta. La respuesta correcta era Vivir Mi Vida, A Puro Dolor y Bailando.',
    compartidos: 0,
    score: 15,
    escuchas: 89,
  },
  {
    id: 7,
    duracion: '90',
    duracionSegundos: 90,
    uso: 'mensaje',
    texto: 'Hola equipo, quería compartir algo muy personal. Mi mamá está en el hospital y hoy la estamos cuidando entre todos. Ella siempre me pidió que mandara un saludo a la radio porque dice que la voz de Valentina la tranquiliza. Así que acá estoy, mandándole este audio para que lo escuche desde su cama. Mami, te amamos, vas a salir adelante.',
    remitente: 'Lucía Mendoza',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20with%20warm%20genuine%20smile%2C%20natural%20makeup%2C%20casual%20look%2C%20soft%20natural%20light%2C%20clean%20bright%20background&width=80&height=80&seq=audio-lucia&orientation=squarish',
    remitenteCiudad: 'Heredia',
    remitentePlan: 'Plan Premium',
    destinoNombre: 'Tardes con Vale',
    destinoRadio: 'Estéreo Capital',
    estado: 'destacado',
    fechaGrabacion: '2026-06-20T19:45:00',
    fechaModeracion: '2026-06-20T19:50:00',
    fechaDestacado: '2026-06-20T19:55:00',
    compartidos: 412,
    score: 1030,
    escuchas: 2847,
  },
  {
    id: 8,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'participacion',
    texto: 'Buenas noches desde Alajuela. Yo también estoy en contra de que quiten el programa de los sábados. Es el único día que puedo escucharlo completo. Por favor no lo saquen del aire.',
    remitente: 'Francisco Jiménez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%2C%20kind%20weathered%20face%2C%20simple%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=audio-francisco&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    remitentePlan: 'Plan Básico',
    destinoNombre: 'Radio Éxito FM 98.5',
    destinoRadio: 'Radio Éxito FM',
    estado: 'pendiente',
    fechaGrabacion: '2026-06-21T17:05:00',
    compartidos: 0,
    score: 15,
    escuchas: 0,
  },
  {
    id: 9,
    duracion: '60',
    duracionSegundos: 60,
    uso: 'saludo',
    texto: 'Saludos a toda la banda desde el Mercado Central. Acá en la sodita los tenemos puestos todo el santo día y la clientela ya pide que no cambiemos de emisora. Hoy estamos de aniversario, cumplimos 5 años de tener la radio como nuestra banda sonora oficial.',
    remitente: 'Eduardo Paredes',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20professional%20style%2C%20friendly%20but%20serious%20expression%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=audio-eduardo&orientation=squarish',
    remitenteCiudad: 'San José',
    remitentePlan: 'Plan Pro',
    destinoNombre: 'Radio Éxito FM 98.5',
    destinoRadio: 'Radio Éxito FM',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-21T10:30:00',
    fechaModeracion: '2026-06-21T10:35:00',
    compartidos: 45,
    score: 90,
    escuchas: 312,
  },
  {
    id: 10,
    duracion: '90',
    duracionSegundos: 90,
    uso: 'concurso',
    texto: 'Hola, soy Diego desde Alajuela. Participo en el concurso del mejor cover. Les mando mi versión de Bailando de Enrique Iglesias en guitarra acústica. Espero que les guste, me tomó toda la semana prepararla. ¡Gracias por la oportunidad!',
    remitente: 'Diego Vargas',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20modern%20studio%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=audio-diego&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    remitentePlan: 'Plan Premium',
    destinoNombre: 'Concurso de Talentos RFW',
    destinoRadio: 'Estéreo Capital',
    estado: 'destacado',
    fechaGrabacion: '2026-06-20T21:00:00',
    fechaModeracion: '2026-06-20T21:10:00',
    fechaDestacado: '2026-06-20T21:15:00',
    compartidos: 534,
    score: 1335,
    escuchas: 3124,
  },
  {
    id: 11,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'saludo',
    texto: 'Buen día desde Puntarenas. Hoy el puerto está hermoso y la brisa del mar nos tiene a todos de buen humor. Les mando un abrazo a todos los que nos escuchan desde la costa.',
    remitente: 'Óscar Fallas',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latino%20man%2C%20fisherman%20casual%20style%2C%20tanned%20skin%2C%20genuine%20wide%20smile%2C%20natural%20coastal%20light%2C%20clean%20background&width=80&height=80&seq=audio-oscar&orientation=squarish',
    remitenteCiudad: 'Puntarenas',
    remitentePlan: 'Plan Básico',
    destinoNombre: 'Radio Éxito FM 98.5',
    destinoRadio: 'Radio Éxito FM',
    estado: 'pendiente',
    fechaGrabacion: '2026-06-21T17:20:00',
    compartidos: 0,
    score: 15,
    escuchas: 0,
  },
  {
    id: 12,
    duracion: '60',
    duracionSegundos: 60,
    uso: 'mensaje',
    texto: 'Quiero agradecer infinitamente a Diego y Natalia por la cobertura de la final del domingo. La mejor transmisión deportiva que he escuchado en mis 40 años de radioescucha. Se pasaron, de verdad. RFW debería darles un premio.',
    remitente: 'Felipe Montero',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20sporty%20casual%20style%2C%20enthusiastic%20expression%2C%20natural%20light%2C%20clean%20background&width=80&height=80&seq=audio-felipe&orientation=squarish',
    remitenteCiudad: 'San José',
    remitentePlan: 'Plan Pro',
    destinoNombre: 'Deporte Total',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-20T23:50:00',
    fechaModeracion: '2026-06-20T23:55:00',
    compartidos: 198,
    score: 396,
    escuchas: 876,
  },
  {
    id: 13,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'participacion',
    texto: 'Hola, acabo de escuchar el debate sobre reguetón vs rock y tengo que decir algo: los dos géneros son válidos, la música es música. Dejen de pelear y pongan lo que la gente pide.',
    remitente: 'Daniela Quirós',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20fit%20Latina%20woman%2C%20sporty%20casual%20look%2C%20energetic%20smile%2C%20bright%20natural%20light%2C%20clean%20background&width=80&height=80&seq=audio-daniela&orientation=squarish',
    remitenteCiudad: 'San José',
    remitentePlan: 'Plan Básico',
    destinoNombre: 'Debate Musical RFW',
    destinoRadio: 'Radio Élite Digital',
    estado: 'rechazado',
    fechaGrabacion: '2026-06-21T15:00:00',
    fechaModeracion: '2026-06-21T15:05:00',
    motivoRechazo: 'Audio inaudible. Se escucha mucho ruido de fondo. Por favor grabá en un lugar más silencioso.',
    compartidos: 0,
    score: 15,
    escuchas: 23,
  },
  {
    id: 14,
    duracion: '90',
    duracionSegundos: 90,
    uso: 'saludo',
    texto: 'Desde la cima del Irazú les mandamos un abrazo a todos los radioescuchas. Somos un grupo de 15 amigos que subimos hoy y adivinen qué... ¡la radio se escucha perfecto incluso a 3400 metros de altura! RFW llega a todas partes. Somos el Grupo Aventura CR y esto es pura vida.',
    remitente: 'Grupo Aventura CR',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20group%20of%20young%20Latino%20friends%2C%20hiking%20gear%2C%20outdoors%20adventure%20style%2C%20joyful%20expressions%2C%20bright%20mountain%20light%2C%20clean%20background&width=80&height=80&seq=audio-aventura&orientation=squarish',
    remitenteCiudad: 'Cartago',
    remitentePlan: 'Plan Premium',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-21T06:50:00',
    fechaModeracion: '2026-06-21T06:55:00',
    compartidos: 89,
    score: 178,
    escuchas: 645,
  },
  {
    id: 15,
    duracion: '60',
    duracionSegundos: 60,
    uso: 'concurso',
    texto: 'Participando en el concurso de la mejor anécdota radiofónica. Una vez estábamos en un viaje familiar y justo cuando pasamos por el túnel se cortó la señal. Mi papá empezó a cantar la canción que estaba sonando a capela y todo el carro lo siguió. Cuando salimos del túnel, la radio seguía y estábamos todos cantando la misma canción. Fue mágico.',
    remitente: 'Gabriela Mora',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20professional%20Latina%20woman%2C%20business%20casual%2C%20confident%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=audio-gabriela&orientation=squarish',
    remitenteCiudad: 'Limón',
    remitentePlan: 'Plan Pro',
    destinoNombre: 'Concurso Anécdotas RFW',
    destinoRadio: 'Radio Élite Digital',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-21T09:00:00',
    fechaModeracion: '2026-06-21T09:05:00',
    compartidos: 234,
    score: 468,
    escuchas: 987,
  },
  {
    id: 16,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'saludo',
    texto: 'Buenos días desde Heredia. Hoy es mi cumpleaños número 30 y lo primero que hice fue sintonizar la radio. Gracias por ser mi compañía todas las mañanas.',
    remitente: 'Valentina Castro',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20style%2C%20creative%20look%2C%20warm%20smile%2C%20soft%20ambient%20light%2C%20clean%20background&width=80&height=80&seq=audio-valentina&orientation=squarish',
    remitenteCiudad: 'Heredia',
    remitentePlan: 'Plan Básico',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'pendiente',
    fechaGrabacion: '2026-06-21T17:35:00',
    compartidos: 0,
    score: 15,
    escuchas: 0,
  },
  {
    id: 17,
    duracion: '90',
    duracionSegundos: 90,
    uso: 'mensaje',
    texto: 'Hola, soy profesor de comunicación en la UCR y quiero felicitarlos por la calidad de contenido. Uso fragmentos de sus programas en mis clases para enseñar locución y periodismo radial. Mis estudiantes analizan cómo manejan las entrevistas, los debates y la interacción con la audiencia. Son una cátedra viviente de cómo se hace buena radio.',
    remitente: 'Dr. Pedro Gutiérrez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20eyes%2C%20simple%20casual%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=audio-pedro&orientation=squarish',
    remitenteCiudad: 'San José',
    remitentePlan: 'Plan Premium',
    destinoNombre: 'Radio Élite Digital 99.1',
    destinoRadio: 'Radio Élite Digital',
    estado: 'destacado',
    fechaGrabacion: '2026-06-20T15:00:00',
    fechaModeracion: '2026-06-20T15:05:00',
    fechaDestacado: '2026-06-20T15:10:00',
    compartidos: 178,
    score: 445,
    escuchas: 1023,
  },
  {
    id: 18,
    duracion: '60',
    duracionSegundos: 60,
    uso: 'participacion',
    texto: 'Hola a todos, escuchando el debate sobre el futuro de la radio digital y tengo que decir que RFW ya es el futuro. Yo antes escuchaba radio FM en el carro nomás, ahora los escucho en todos lados. En el gym, en el bus, en la oficina. La radio digital es el presente y ustedes son la prueba.',
    remitente: 'Natalia Campos',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20in%20her%2030s%2C%20warm%20friendly%20smile%2C%20casual%20chic%20style%2C%20soft%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=audio-natalia&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    remitentePlan: 'Plan Pro',
    destinoNombre: 'Debate Radio Digital RFW',
    destinoRadio: 'Radio Élite Digital',
    estado: 'aprobado',
    fechaGrabacion: '2026-06-21T14:00:00',
    fechaModeracion: '2026-06-21T14:05:00',
    compartidos: 112,
    score: 224,
    escuchas: 534,
  },
  {
    id: 19,
    duracion: '30',
    duracionSegundos: 30,
    uso: 'concurso',
    texto: 'Respuesta al concurso relámpago: el locutor que más tiempo lleva al aire en RFW es Diego Montenegro con 8 años consecutivos. ¡Espero ganar!',
    remitente: 'Javier Núñez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20trendy%20street%20style%2C%20charismatic%20smile%2C%20urban%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=audio-javier&orientation=squarish',
    remitenteCiudad: 'San José',
    remitentePlan: 'Plan Básico',
    destinoNombre: 'Concurso Relámpago RFW',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'rechazado',
    fechaGrabacion: '2026-06-21T16:00:00',
    fechaModeracion: '2026-06-21T16:05:00',
    motivoRechazo: 'Respuesta incorrecta. Diego Montenegro lleva 6 años, no 8. El récord lo tiene Natalia Vargas con 10 años.',
    compartidos: 0,
    score: 15,
    escuchas: 45,
  },
  {
    id: 20,
    duracion: '90',
    duracionSegundos: 90,
    uso: 'saludo',
    texto: 'Hola equipo, soy Mauricio desde Guanacaste. Hoy estamos celebrando el cumpleaños de mi hija Valentina — sí, le pusimos Valentina por la locutora, no se rían. Ella tiene 7 años y ya es fan número uno de Tardes con Vale. Les mando un audio de ella cantando su canción favorita. ¡Feliz cumple Vale junior!',
    remitente: 'Mauricio Chaves',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20beach%20casual%20style%2C%20tanned%20skin%2C%20bright%20confident%20smile%2C%20natural%20sunlight%2C%20clean%20background&width=80&height=80&seq=audio-mauricio&orientation=squarish',
    remitenteCiudad: 'Guanacaste',
    remitentePlan: 'Plan Premium',
    destinoNombre: 'Tardes con Vale',
    destinoRadio: 'Estéreo Capital',
    estado: 'destacado',
    fechaGrabacion: '2026-06-20T16:30:00',
    fechaModeracion: '2026-06-20T16:35:00',
    fechaDestacado: '2026-06-20T16:40:00',
    compartidos: 678,
    score: 1695,
    escuchas: 4521,
  },
];

export const scoreAccionesAudio: ScoreAccionAudio[] = [
  {
    id: 'grabar',
    accion: 'Grabar Audio Mensaje',
    icono: 'ri-mic-fill',
    color: 'from-violet-500 to-purple-500',
    descripcion: 'Sumás 15 puntos cada vez que grabás y enviás un audio mensaje. La participación más natural suma más.',
    puntos: 15,
  },
  {
    id: 'compartir',
    accion: 'Audio Compartido',
    icono: 'ri-share-forward-line',
    color: 'from-emerald-500 to-teal-500',
    descripcion: 'Sumás 5 puntos por cada persona que comparte tu audio mensaje en la comunidad.',
    puntos: 5,
  },
  {
    id: 'destacado',
    accion: 'Audio Destacado',
    icono: 'ri-star-fill',
    color: 'from-amber-500 to-yellow-500',
    descripcion: 'Sumás 25 puntos cuando tu audio mensaje es destacado por el locutor y sale al aire.',
    puntos: 25,
  },
];

export const reglasAudio: ReglaAudio[] = [
  {
    id: 1,
    titulo: 'Nunca reproducir automáticamente',
    descripcion: 'Ningún audio mensaje se reproduce sin que el oyente o el locutor lo inicien explícitamente. Esto protege la experiencia de escucha, evita interrupciones molestas en la transmisión y respeta al oyente. Cada reproducción requiere un clic consciente.',
    icono: 'ri-volume-up-line',
    color: 'from-rose-500 to-pink-500',
  },
  {
    id: 2,
    titulo: 'Duración según tu plan',
    descripcion: 'Plan Básico: 30 segundos. Plan Pro: 60 segundos. Plan Premium: 90 segundos. Cada plan habilita una duración máxima distinta para tus audio mensajes. Subí de plan para poder expresarte con más tiempo.',
    icono: 'ri-timer-line',
    color: 'from-amber-500 to-orange-500',
  },
  {
    id: 3,
    titulo: 'Moderación antes de ser público',
    descripcion: 'Todo audio mensaje pasa por moderación antes de ser visible para la comunidad. El locutor o moderador escucha, aprueba, rechaza o destaca. Esto garantiza contenido de calidad y evita abusos del sistema.',
    icono: 'ri-shield-check-line',
    color: 'from-emerald-500 to-green-500',
  },
  {
    id: 4,
    titulo: 'Todo audio vive dentro de Cabina',
    descripcion: 'Grabar, enviar, escuchar y moderar audio mensajes sucede exclusivamente en la Cabina. No hay formularios externos. No hay reproductores automáticos en otras secciones. La Cabina es el único canal para los audio mensajes.',
    icono: 'ri-broadcast-line',
    color: 'from-violet-500 to-purple-500',
  },
];

export const globalStatsAudio = {
  audiosHoy: 198,
  audiosAprobados: 145,
  audiosDestacados: 18,
  audiosPendientes: 42,
  audiosRechazados: 11,
  plan30: 89,
  plan60: 72,
  plan90: 37,
  scoreTotalGenerado: 6295,
  audioMasEscuchado: 'Lucía Mendoza - Mensaje a su mamá (2,847 escuchas)',
  escuchasTotales: 21345,
};

export const duracionLabels: Record<DuracionAudio, { label: string; plan: string; color: string; bg: string }> = {
  '30': { label: '30s', plan: 'Básico', color: 'text-foreground-600', bg: 'bg-foreground-100' },
  '60': { label: '60s', plan: 'Pro', color: 'text-primary-600', bg: 'bg-primary-100' },
  '90': { label: '90s', plan: 'Premium', color: 'text-amber-600', bg: 'bg-amber-100' },
};

export const usoLabels: Record<UsoAudio, { label: string; icono: string; color: string }> = {
  saludo: { label: 'Saludo', icono: 'ri-message-3-line', color: 'text-rose-600 bg-rose-100' },
  concurso: { label: 'Concurso', icono: 'ri-trophy-line', color: 'text-amber-600 bg-amber-100' },
  participacion: { label: 'Participación', icono: 'ri-chat-smile-2-line', color: 'text-emerald-600 bg-emerald-100' },
  mensaje: { label: 'Mensaje', icono: 'ri-mail-line', color: 'text-violet-600 bg-violet-100' },
};

export const estadoModeracionLabels: Record<EstadoModeracion, { label: string; icono: string; dot: string }> = {
  pendiente: { label: 'Pendiente', icono: 'ri-time-line', dot: 'bg-foreground-400' },
  aprobado: { label: 'Aprobado', icono: 'ri-check-line', dot: 'bg-emerald-500' },
  rechazado: { label: 'Rechazado', icono: 'ri-close-line', dot: 'bg-rose-500' },
  destacado: { label: 'Destacado', icono: 'ri-star-fill', dot: 'bg-amber-500 animate-pulse' },
};

export function getAudiosPorEstado(estado: EstadoModeracion): AudioMensaje[] {
  return audioMensajes.filter((a) => a.estado === estado);
}

export function getAudiosPorUso(uso: UsoAudio): AudioMensaje[] {
  return audioMensajes.filter((a) => a.uso === uso);
}

export function getAudiosPorDuracion(duracion: DuracionAudio): AudioMensaje[] {
  return audioMensajes.filter((a) => a.duracion === duracion);
}

export function getMasEscuchados(): AudioMensaje[] {
  return [...audioMensajes].sort((a, b) => b.escuchas - a.escuchas);
}

export function getMasCompartidos(): AudioMensaje[] {
  return [...audioMensajes].sort((a, b) => b.compartidos - a.compartidos);
}

export function getMayorScore(): AudioMensaje[] {
  return [...audioMensajes].sort((a, b) => b.score - a.score);
}

export function getMasRecientes(): AudioMensaje[] {
  return [...audioMensajes].sort((a, b) => new Date(b.fechaGrabacion).getTime() - new Date(a.fechaGrabacion).getTime());
}